import { render, staticRenderFns } from "./onlitxswd.vue?vue&type=template&id=68d3769c&scoped=true&"
import script from "./onlitxswd.vue?vue&type=script&lang=js&"
export * from "./onlitxswd.vue?vue&type=script&lang=js&"
import style0 from "./onlitxswd.vue?vue&type=style&index=0&id=68d3769c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3769c",
  null
  
)

export default component.exports